<template>
  <div>
    <b-row class="mx-25 align-items-center">
      <h3 class="mr-50">
        <feather-icon size="20" icon="FileIcon" />
        معاملات التوسّط
      </h3>
      <div class="ml-auto d-flex align-center"
        v-if="!canAddTransaction">
        <search-input
          class="mr-1"
          placeholder="البحث بحسب الجهة"
          v-model="destination"
        />
        {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
        <div>
          <b-button
            @click="showFileDownloadModal"
            variant="success"
            v-can="{ slug: $route.meta.slug, action: 'C' }"
          >
            <feather-icon class="mx-25" icon="PlusIcon" />
            معاملة توسّط جديدة
          </b-button>
        </div>
      </div>
    </b-row>

    <hr />

    <b-row>
      <b-col cols="12" v-if="canAddTransaction">
        <alert
          massage="لا يمكنك تقديم المعاملات قبل أن تتم الموافقة على اعتماد الملف الشخصي"
          class="w-100 mx-1"
        ></alert>
      </b-col>
      <b-col cols="12" v-else>
        <data-table
          ref="requestesTable"
          ep="v2/files-qrs/index"
          :fields="fields"
        >
          <template #cell(status)="{ value }">
            <qr-status-formatter :value="value" />
          </template>
          <template #cell(created_at)="{ value }">
            {{ formatDate(value, 'Asia/Damascus') }}
          </template>
          <template #cell(actions)="{ item: { id, path } }">
            <b-button
              class="mr-50"
              size="sm"
              @click="$router.push({ name: 'qr-scan-log', params: { id } })"
              variant="flat-info"
              v-can="{ slug: $route.meta.slug, action: 'S' }"
            >
              <feather-icon class="mx-25" icon="ListIcon" />
              سجل عمليات المسح
            </b-button>
            <b-button
              size="sm"
              @click="$router.push({ name: 'file-view', query: { ep: path } })"
              variant="flat-success"
              v-can="{ slug: $route.meta.slug, action: 'S' }"
            >
              <feather-icon class="mx-25" icon="EyeIcon" />
              عرض الملف
            </b-button>
          </template>
        </data-table>
      </b-col>
    </b-row>

    <b-modal
      title="إنشاء طلب توسّط جديد"
      centered
      v-model="fileDownloadModal"
      footer-class="removed"
      no-close-on-backdrop
    >
      <b-form @submit.prevent="onFileDialogConfirmed">
        <validation-observer ref="simpleRules">
          <form-select
            id="innegov"
            ep="v2/selects/mediation-request-destination"
            label="الجهة"
            :reduce="(x) => x.id"
            :getOptionLabel="(x) => x.name_ar"
            v-model="id"
          
          />
          <form-input
            v-if="isNewDestination"
            label="الجهة الجديدة"
            rules="required"
            v-model="destination"
          />

          <hr />
          <div class="w-100 d-flex justify-content-end">
          
            <loader-btn
              label="إنشاء"
              loadingLabel="جارٍ الإنشاء ..."
              :loading="loading"
              variant="success"
              type="submit"
              @click.prevent="onFileDialogConfirmed"
            >
            </loader-btn>
          </div>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import QrStatusFormatter from "../../components/QrStatusFormatter.vue";
import { BRow, BButton, BCol, BCard , BForm} from "bootstrap-vue";
import { required, email } from '@validations'
import DataTable from "@/components/data-table";
import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import Alert from "@/components/Alert.vue";
import debounce from "lodash.debounce";
import FormInput from "@/components/form-input/index.vue";
import FormSelect from  "@/components/form-select/index.vue";
import SearchInput from "@/components/SearchInput.vue";
import LoaderBtn from "@/components/loader-btn.vue";
import { ValidationObserver } from "vee-validate";
import { formatDate } from "@/utils/utils";

export default {
  components: {
    ValidationObserver,
    FormSelect ,
    FormInput ,
    DataTable,
    BRow,
    BButton,
    BCol,
    BCard,
    QrStatusFormatter,
    FormModal,
    SearchInput,
    LoaderBtn ,
    BForm ,
    Alert
  },
  data() {
    return {
      fileDownloadForm: {
        destination: null,
      },
      id:null,
      destination: null,
      isNewDestination : false ,
      fileFormSchema: {
        // destination: {
        //   key: "destination",
        //   component: "FormInput",
        //   attrs: {
        //     label: "الجهة",
        //     rules: "required",
        //   },
        // },
        destination: {
          component: "FormSelect",
          key: "id",
          attrs: {
            id: "meeting-type",
            label: "الجهة",
            rules: "required",
            ep: "v2/selects/mediation-request-destination",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
          },
        },
        
       
        
      },
      FormSchema: {
        destination: {
          key: "destination",
          component: "FormInput",
          attrs: {
            label: "الجهة",
            rules: "required",
          },
        },
        
       
        
      },
      fileDownloadModal: false,
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "user",
          label: "المستخدم",
        },
        {
          key: "destination",
          label: "الجهة",
        },
        {
          key: "status",
          label: "الحالة",
        },
        {
          key: "created_at",
          label: "تاريخ الإنشاء",
        },
        { key: "actions", label: " " },
      ],
    };
  },
  computed: {
    ...mapGetters("Transactions/MediationRequests", ["loading"]),
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },
  watch: {
    destination: debounce(function (value) {
      this.$refs.requestesTable.setQueryParams({ destination: value });
      this.$refs.requestesTable.refreshTable();
    }, 300),
  },
  watch: {
    id(newDes, oldDes) {
      if (newDes === 'other' ) {
        this.isNewDestination = true
      } else{
        this.isNewDestination = false
        this.destination = null
      }
    }
  },

  methods: {
    ...mapActions("Transactions/MediationRequests", ["createQrFile"]),
    async onFileDialogConfirmed(form) {
      await this.$refs.simpleRules.validate().then(success => {
        if (success) {
          let form = {}
          if(this.id != 'other')
          {
            form = {"id" : this.id }
          }
          else{
            form = {"destination" : this.destination }

          }
          

          this.createQrFile(form).then(() => {
            this.fileDownloadModal = false;
            this.id = null ;
            this.destination = null ;
            this.$refs.requestesTable.refreshTable();
          });
        }
      })
    },
    formatDate(value, formFormat){
      return formatDate(value, formFormat)
    },
    // async onFileDialogConfirmed(form) {
    //   console.log(form)
    //   // await this.createQrFile(form).then(() => {
    //   //   this.fileDownloadModal = false;
    //   // });
    // },

    showFileDownloadModal() {
      this.editForm = {
        destination: false,
      };
      this.fileDownloadModal = true;
    },
    refreshTable() {
      this.$refs.requestesTable.refresh();
    },
  },
};
</script>
